export const IntegrationTypeConfig = {
  gdrive: {
    name: "Google Drive",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/google-drive.svg",
  },
  gmail: {
    name: "Gmail",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/gmail.svg",
  },
  gspreadsheets: {
    name: "Google Sheets",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/google-sheets.svg",
  },
  gcalendar: {
    name: "Google Calendar",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/google-calendar.png",
  },
  slack: {
    name: "Slack",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/slack.svg",
  },
  airtable: {
    name: "Airtable",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/airtable.png",
  },
  notion: {
    name: "Notion",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/notion.png",
  },
  calendly: {
    name: "Calendly",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/calendly.svg",
  },
  typeform: {
    name: "Typeform",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/typeform.svg",
  },
  telegram: {
    name: "Telegram",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/telegram.svg",
  },
  outlook: {
    name: "Outlook",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/outlook.png",
  },
  outlook_shared: {
    name: "Outlook Shared Mailboxes",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/outlook.png",
  },
  onedrive: {
    name: "OneDrive",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/onedrive.png",
  },
  sharepoint: {
    name: "SharePoint",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/sharepoint.png",
  },
  teams: {
    name: "Microsoft Teams",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/msteams.png",
  },
  linear: {
    name: "Linear",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/linear.svg",
  },
  jira: {
    name: "Jira",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/external-integrations/external-integrations/jira.png",
  },
  clipone: {
    name: "ClipOne",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/clipone.png",
  },
  whatsapp: {
    name: "WhatsApp",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/whatsapp.svg",
  },
  servicenow: {
    name: "ServiceNow",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/servicenow.png",
  },
  api: {
    name: "API",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/api-request.svg",
  },
  zendesk: {
    name: "Zendesk",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/zendesk.png",
  },
  freshdesk: {
    name: "Freshdesk",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/freshdesk.png",
  },
  excel: {
    name: "Excel",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/excelNode.png",
  },
  attio: {
    name: "Attio",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/attio.png",
  },
  salesforce: {
    name: "Salesforce",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/salesforce.png",
  },
  confluence: {
    name: "Confluence",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/confluence.png",
  },
  opentable: {
    name: "OpenTable",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/opentable.png",
  },
  opera: {
    name: "Opera",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/oracle.png",
  },
  azure_apim: {
    name: "Azure APIM",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/azure_api_management.svg",
  },
} as const;

export type IntegrationType = keyof typeof IntegrationTypeConfig;
